import React from "react";
import { Link } from "react-router-dom";

import CampaignStatusBadge from "./CampaignStatusBadge";

const CampaignTable = ({ campaigns }) => {

    return (

        <div className="campaign-table">

            <table>

                <thead>

                    <tr>

                        <th>Title</th>

                        <th>Type</th>

                        <th>Audience</th>

                        <th>Start</th>

                        <th>End</th>

                        <th>Status</th>

                        <th>Action</th>

                    </tr>

                </thead>

                <tbody>

                    {

                        campaigns.map((campaign) => (

                            <tr key={campaign._id}>

                                <td>
                                    {campaign.title}
                                </td>

                                <td>
                                    {campaign.campaignType}
                                </td>

                                <td>
                                    {campaign.targetAudience}
                                </td>

                                <td>
                                    {new Date(campaign.startDate).toLocaleDateString()}
                                </td>

                                <td>
                                    {new Date(campaign.endDate).toLocaleDateString()}
                                </td>

                                <td>

                                    <CampaignStatusBadge
                                        status={campaign.status}
                                    />

                                </td>

                                <td>

                                    <Link
                                        to={`/admin/marketing/${campaign._id}`}
                                    >
                                        View
                                    </Link>

                                </td>

                            </tr>

                        ))

                    }

                </tbody>

            </table>

        </div>

    );

};

export default CampaignTable;